"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var app_1 = require("firebase/app");
var firestore_1 = require("firebase/firestore");
var errorHandler_1 = __importDefault(require("../errorHandler"));
var tracking_events_1 = require("../../models/tracking-events");
var sms_events_1 = require("../../models/sms-events");
var scan_events_1 = require("../../models/scan-events");
var delivery_attempts_1 = require("../../models/delivery-attempts");
var types_1 = require("./types");
var types_2 = require("../types");
var types_3 = require("@swyft/types");
var ActivityLogController = /** @class */ (function () {
    /**
     * Creates instance with provided config to setup Firebase app.
     * @param {FirebaseOptions} config Firebase configuration to initialize app.
     */
    function ActivityLogController(config) {
        var _this = this;
        /**
         * Get a list of all activity logs for a label. An activity log is an aggregation of various lifecycle events for a label.
         * @param params the organization and label to get activities for. The types of events to retrieve in the activity log can also be specified.
         * @returns a list of activity logs
         */
        this.getList = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getActivityLog(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getTrackingEvents = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var filter, sort, events_1, err_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        filter = params.filter;
                        sort = params.sort;
                        if (!sort && (filter === null || filter === void 0 ? void 0 : filter.prune)) {
                            sort = {
                                field: "timestamp",
                                order: types_2.SortOrder.DESC
                            };
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, tracking_events_1.getList)(this.db, __assign({ org: {
                                    id: (_a = filter === null || filter === void 0 ? void 0 : filter.org.id) !== null && _a !== void 0 ? _a : ""
                                }, label: {
                                    id: (_b = filter === null || filter === void 0 ? void 0 : filter.label.id) !== null && _b !== void 0 ? _b : ""
                                } }, (sort && {
                                sort: {
                                    field: sort === null || sort === void 0 ? void 0 : sort.field,
                                    order: (sort === null || sort === void 0 ? void 0 : sort.order) === types_2.SortOrder.ASC ? "asc" : "desc"
                                }
                            })))];
                    case 2:
                        events_1 = _c.sent();
                        if (filter === null || filter === void 0 ? void 0 : filter.prune) {
                            events_1 = events_1.filter(function (event, idx) {
                                // need to consider the sort order
                                var safeIdx = function (idx) {
                                    return idx < 0 ? 0 : idx >= events_1.length ? events_1.length - 1 : idx;
                                };
                                var olderIdx = (sort === null || sort === void 0 ? void 0 : sort.order) === types_2.SortOrder.DESC
                                    ? safeIdx(idx + 1)
                                    : safeIdx(idx - 1);
                                var newerIdx = (sort === null || sort === void 0 ? void 0 : sort.order) === types_2.SortOrder.DESC
                                    ? safeIdx(idx - 1)
                                    : safeIdx(idx + 1);
                                // always return the first, and the last event
                                if (idx === 0 || idx === events_1.length - 1) {
                                    return true;
                                }
                                // for certain events, keep the oldest occurence, instead of the newer duplicate
                                if (event.state === types_3.TrackingEventState.IN_TRANSIT) {
                                    return events_1[olderIdx].state !== types_3.TrackingEventState.IN_TRANSIT;
                                }
                                // for all other events, remove duplicate events next to each other, and keep the most recent/newer occurence only
                                return events_1[newerIdx].state !== event.state;
                            });
                        }
                        return [2 /*return*/, { data: events_1, total: events_1.length }];
                    case 3:
                        err_2 = _c.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_2)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getSmsEvents = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var filter, events, err_3;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        filter = params.filter;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, sms_events_1.getList)(this.db, {
                                org: {
                                    id: (_a = filter === null || filter === void 0 ? void 0 : filter.org.id) !== null && _a !== void 0 ? _a : ""
                                },
                                label: {
                                    id: (_b = filter === null || filter === void 0 ? void 0 : filter.label.id) !== null && _b !== void 0 ? _b : ""
                                }
                            })];
                    case 2:
                        events = _c.sent();
                        return [2 /*return*/, { data: events, total: events.length }];
                    case 3:
                        err_3 = _c.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_3)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getScanEvents = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var filter, events, err_4;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        filter = params.filter;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, scan_events_1.getList)(this.db, {
                                org: {
                                    id: (_a = filter === null || filter === void 0 ? void 0 : filter.org.id) !== null && _a !== void 0 ? _a : ""
                                },
                                label: {
                                    id: (_b = filter === null || filter === void 0 ? void 0 : filter.label.id) !== null && _b !== void 0 ? _b : ""
                                }
                            })];
                    case 2:
                        events = _c.sent();
                        return [2 /*return*/, { data: events, total: events.length }];
                    case 3:
                        err_4 = _c.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_4)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getDeliveryAttempts = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var filter, events, err_5;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        filter = params.filter;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, delivery_attempts_1.getList)(this.db, {
                                org: {
                                    id: (_a = filter === null || filter === void 0 ? void 0 : filter.org.id) !== null && _a !== void 0 ? _a : ""
                                },
                                label: {
                                    id: (_b = filter === null || filter === void 0 ? void 0 : filter.label.id) !== null && _b !== void 0 ? _b : ""
                                }
                            })];
                    case 2:
                        events = _c.sent();
                        return [2 /*return*/, { data: events, total: events.length }];
                    case 3:
                        err_5 = _c.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_5)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getActivityLog = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var sort, filter, meta, activityLogQueries, eventsResults, events, sortedEvents, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sort = params.sort, filter = params.filter, meta = params.meta;
                        activityLogQueries = [
                            {
                                type: types_1.ActivityType.TRACKING,
                                query: this.getTrackingEvents
                            },
                            {
                                type: types_1.ActivityType.SCAN,
                                query: this.getScanEvents
                            },
                            {
                                type: types_1.ActivityType.COMMS,
                                query: this.getSmsEvents
                            },
                            {
                                type: types_1.ActivityType.DELIVERY_ATTEMPTS,
                                query: this.getDeliveryAttempts
                            },
                        ].filter(function (q) {
                            return filter && filter.type ? filter.type.includes(q.type) : true;
                        });
                        // sorted by descending timestamp order, by default
                        if (!sort) {
                            sort = {
                                field: "timestamp",
                                order: "desc"
                            };
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.allSettled(activityLogQueries.map(function (q) { return q.query({ filter: filter, meta: meta }); }))];
                    case 2:
                        eventsResults = _a.sent();
                        events = eventsResults.flatMap(function (resultSet, index) {
                            if (resultSet.status !== "fulfilled") {
                                return [];
                            }
                            if ((0, types_3.determineIfTrackingEvent)(resultSet.value.data[0])) {
                                return resultSet.value.data.map(function (d) { return ({
                                    id: d.id,
                                    type: types_1.ActivityType.TRACKING,
                                    details: d.state,
                                    timestamp: d.timestamp,
                                    data: d
                                }); });
                            }
                            else if ((0, types_3.determineIfSMSEvent)(resultSet.value.data[0])) {
                                return resultSet.value.data.map(function (d) { return ({
                                    id: d.id,
                                    type: types_1.ActivityType.COMMS,
                                    details: d.type,
                                    timestamp: d.createdAt,
                                    data: d
                                }); });
                            }
                            else if ((0, types_3.determineIfScanEvent)(resultSet.value.data[0])) {
                                return resultSet.value.data.map(function (d) { return ({
                                    id: d.id,
                                    type: types_1.ActivityType.SCAN,
                                    details: d.type,
                                    timestamp: d.timestamp,
                                    data: d
                                }); });
                            }
                            else if ((0, types_3.determineIfDeliveryAttempt)(resultSet.value.data[0])) {
                                return resultSet.value.data.map(function (d) {
                                    var details = "";
                                    if (d.success) {
                                        details = types_1.DeliveryAttemptDetails.SUCCESS;
                                    }
                                    else if (d.errorCode && types_1.DeliveryAttemptDetails[d.errorCode]) {
                                        details = types_1.DeliveryAttemptDetails[d.errorCode];
                                    }
                                    else {
                                        details = types_1.DeliveryAttemptDetails.FAILURE;
                                    }
                                    return {
                                        id: d.id,
                                        type: types_1.ActivityType.DELIVERY_ATTEMPTS,
                                        details: details,
                                        timestamp: d.createdAt,
                                        data: d
                                    };
                                });
                            }
                            else {
                                return [];
                            }
                        });
                        sortedEvents = sort && sort.field === "timestamp"
                            ? events.sort(function (logA, logB) {
                                var _a, _b, _c, _d;
                                if (!logA.timestamp || !logB.timestamp) {
                                    return 0;
                                }
                                if (((_a = logA.timestamp) === null || _a === void 0 ? void 0 : _a.valueOf()) > ((_b = logB.timestamp) === null || _b === void 0 ? void 0 : _b.valueOf())) {
                                    return (sort === null || sort === void 0 ? void 0 : sort.order) === types_2.SortOrder.ASC ? 1 : -1;
                                }
                                else if (((_c = logA.timestamp) === null || _c === void 0 ? void 0 : _c.valueOf()) < ((_d = logB.timestamp) === null || _d === void 0 ? void 0 : _d.valueOf())) {
                                    return (sort === null || sort === void 0 ? void 0 : sort.order) === types_2.SortOrder.ASC ? -1 : 1;
                                }
                                else {
                                    return 0;
                                }
                            })
                            : events;
                        return [2 /*return*/, { data: sortedEvents, total: events.length }];
                    case 3:
                        err_6 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_6)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var firebaseApp = (0, app_1.initializeApp)(config);
        this.db = (0, firestore_1.getFirestore)(firebaseApp);
    }
    return ActivityLogController;
}());
exports["default"] = ActivityLogController;
